import de from '@translations/de/editCatalogue.json';
import en from '@translations/en/editCatalogue.json';
import pl from '@translations/pl/editCatalogue.json';
import sl from '@translations/sl/editCatalogue.json';
import uk from '@translations/uk/editCatalogue.json';
import bg from '@translations/bg/editCatalogue.json';
import cz from '@translations/cz/editCatalogue.json';
import fr from '@translations/fr/editCatalogue.json';
import gr from '@translations/gr/editCatalogue.json';
import it from '@translations/it/editCatalogue.json';
import pr from '@translations/pr/editCatalogue.json';
import ru from '@translations/ru/editCatalogue.json';
import sk from '@translations/sk/editCatalogue.json';
import sp from '@translations/sp/editCatalogue.json';
import tr from '@translations/tr/editCatalogue.json';
import hu from '@translations/hu/editCatalogue.json';
import { ITranslations } from '@/types/common';
import { EditCatalogueTransFields } from './types';

export const editCatalogueTranslations: ITranslations<EditCatalogueTransFields> = {
  name: 'editCatalogue',
  de,
  en,
  pl,
  sl,
  uk,
  bg,
  cz,
  fr,
  gr,
  it,
  pr,
  ru,
  sk,
  sp,
  tr,
  hu,
};
